import type { ApmBase } from '@elastic/apm-rum';
import appConfig from 'config';
import { isWindowAvailable } from 'constants/is-window-available';

let apm: Promise<ApmBase | undefined> | null = null;

export async function getApm(): Promise<ApmBase | undefined> {
  if (!isWindowAvailable) return undefined;
  if (apm) return apm;

  if (window.apm) {
    apm = Promise.resolve(window.apm);
    return apm;
  }

  // For now, we dynamically import APM RUM to save fragment sizes
  // When we work on WPIP-76721, we can ensure page loads this and adds to window
  apm = import('@elastic/apm-rum')
    .then(({ init }) =>
      init({
        serviceName: appConfig?.applicationName,
        serverUrl: appConfig?.thirdParty.apmRum.url,
        serviceVersion: appConfig?.version,
        environment: appConfig?.env,
        instrument: false,
        transactionSampleRate: appConfig?.thirdParty.apmRum.transactionSampleRate,
        logLevel: appConfig?.thirdParty.apmRum.logLevel,
      }),
    )
    .catch(e => {
      console.error('Failed to dynamically import APM:', e);
      apm = null;
      return undefined;
    });

  return apm;
}
